import styled from "styled-components";
import { MediaQuery } from "../../hooks/useDeviceType";
import {
  GAINSBORO,
  GHOST_WHITE,
  NORMAL_HEIGHT,
  PRIMARY_FONT,
  SECONDARY_FONT,
  SECONDARY_SIZE,
  SLIM_WEIGHT,
  SMALL_TITLE_SIZE,
} from "../../utils/variables";

export const Container = styled.section`
  max-width: 110rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 7rem;
  padding: 10rem 12rem;

  @media ${MediaQuery.isTablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 4rem;
    padding: 8rem 6rem;
  }

  @media ${MediaQuery.isMobile} {
    flex-direction: column;
    gap: 0;
    align-items: stretch;
    padding: 6rem 3rem;
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;

  @media ${MediaQuery.isTablet} {
    width: 100%;
  }

  @media ${MediaQuery.isMobile} {
    width: 100%;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${SECONDARY_FONT};
  margin-bottom: 4rem;

  &::after {
    content: "";
    width: 100%;
    height: 1px;
    display: block;
    background-color: ${GAINSBORO};
    opacity: 0.4;
    margin-left: 2rem;
  }
`;

export const Heading = styled.h2`
  margin-left: 1rem;
  font-family: ${PRIMARY_FONT};
  font-size: ${SMALL_TITLE_SIZE};
  white-space: nowrap;
`;

export const Text = styled.p`
  color: ${GAINSBORO};
  font-weight: ${SLIM_WEIGHT};
  font-size: ${SECONDARY_SIZE};
  line-height: ${NORMAL_HEIGHT};
  margin-bottom: 2rem;
`;

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 3rem;
`;

export const Detail = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.7rem 1rem;
  color: ${GHOST_WHITE};
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid rgba(218, 221, 216, 0.2);
  border-radius: 999px;
  font-family: ${SECONDARY_FONT};
  font-size: 1.2rem;

  &::before {
    content: "";
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.7rem;
    border-radius: 50%;
    background: #71b7a7;
    box-shadow: 0 0 1rem rgba(113, 183, 167, 0.6);
  }
`;

export const Traits = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 1.2rem;
`;

export const Trait = styled.span`
  padding: 0.6rem 1rem;
  color: ${GAINSBORO};
  border: 1px solid rgba(218, 221, 216, 0.16);
  border-radius: 999px;
  font-family: ${SECONDARY_FONT};
  font-size: 1.2rem;
`;

export const PhotoContainer = styled.figure`
  max-height: 60rem;
  min-width: 40rem;
  max-width: 40rem;
  padding: 1px;
  position: relative;
  border-radius: 1.6rem;
  background: linear-gradient(
    145deg,
    rgba(176, 210, 229, 0.65),
    rgba(93, 149, 138, 0.22) 50%,
    rgba(128, 101, 163, 0.5)
  );
  box-shadow: 0 2.4rem 7rem rgba(0, 0, 0, 0.38);
  align-self: center;

  &::before {
    content: "";
    position: absolute;
    inset: 8% -8% -8% 8%;
    z-index: -1;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(74, 133, 143, 0.3),
      rgba(93, 73, 126, 0.16) 45%,
      transparent 72%
    );
    filter: blur(3.5rem);
  }

  &:hover img {
    filter: brightness(1);
    transform: scale(1.015);
  }

  @media ${MediaQuery.isTablet} {
    margin-top: 6rem;
    min-width: 0;
    width: min(100%, 36rem);
  }

  @media ${MediaQuery.isMobile} {
    margin-top: 4rem;
    min-width: 0;
    width: 100%;
    max-width: 44rem;
    max-height: unset;

    img {
      filter: brightness(1);
    }
  }
`;

export const Photo = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 1.5rem;
  filter: brightness(0.92);
  transition: filter 0.35s ease, transform 0.35s ease;
`;
